import { Badge, Grid, Image } from "antd-mobile";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { HomeCard } from "../../../../components";
import { envChangeType, envType } from "../../../../plugins/utils";
import { useGetSummary } from "../../hooks/summary.hooks";
import styles from "./style.module.scss";
const Menu = ({ homeCardContainerStyle = "", backCardStyle = "", frontCardStyle = "" }) => {
  const { t } = useTranslation();

  const { data: summary } = useGetSummary({});

  const navigate = useNavigate();
  const menu = [
    {
      key: "transaction",
      icon: "images/home/trans-record.png",
      title: t("mobile.home.menu.transaction"),
      url: "/transaction",
    },
    {
      key: "commission",
      icon: "images/home/comission.png",
      title: t("mobile.home.menu.comission"),
      url: "/commission/?tab=comission_statement",
    },
    {
      key: "downline",
      icon: "images/home/downline-report.png",
      title: t("mobile.home.menu.downline"),
      url: "/downline",
    },
    {
      key: "financial",
      icon: "images/home/financial-report.png",
      title: t("mobile.home.menu.financial"),
      url: "/financial",
    },
    {
      key: "product_report",
      icon: "images/home/product-report.png",
      title: t("mobile.home.menu.productReport"),
      url: "/product?tab=report",
    },

    {
      key: `${envChangeType("REACT_APP_SHOW_HANDLING_FEE", envType.BOOLEAN) === true ? "handling_fee_report" : "product_data"}`,
      icon: "images/home/product-data.png",
      title: `${
        envChangeType("REACT_APP_SHOW_HANDLING_FEE", envType.BOOLEAN) === true
          ? t("mobile.home.menu.handlingFeeStatement")
          : t("mobile.home.menu.productData")
      }`,
      url: `${
        envChangeType("REACT_APP_SHOW_HANDLING_FEE", envType.BOOLEAN) === true
          ? "/handlingfee?tab=handling_fee_statement"
          : "/product?tab=data"
      }`,
    },
    {
      key: "event",
      icon: "images/home/activity.png",
      title: t("mobile.home.menu.activity"),
      url: "/home/event",
    },
    {
      key: "bet_inquiry",
      icon: "images/home/bet-inquiry.png",
      title: t("mobile.menu.betInquiry"),
      url: "/betinquiry",
    },
  ];

  const handleOpenPage = (url) => {
    navigate(url);
  };

  const renderMenu = (item) => {
    if (item.key === "transaction") {
      return (
        <div className={styles.menu} onClick={() => handleOpenPage(item.url)}>
          <Badge
            className={styles.badge}
            content={summary && summary.total_unreceive > 0 ? Badge.dot : null}
          />
          <Image
            width={20}
            height={20}
            fit={"contain"}
            className={styles.icon}
            src={item.icon}
            alt={item.title}
          />
          <div className={styles.menuTitle}>
            <div className={styles.title}>{item.title}</div>
          </div>
        </div>
      );
    }
    return (
      <div className={styles.menu} onClick={() => handleOpenPage(item.url)}>
        <Image
          width={20}
          height={20}
          fit={"contain"}
          className={styles.icon}
          src={item.icon}
          alt={item.title}
        />
        <div className={styles.menuTitle}>
          <div className={styles.title}>{item.title}</div>
        </div>
      </div>
    );
  };

  return (
    <HomeCard
      title={t("mobile.home.quickEntry")}
      containerStyle={homeCardContainerStyle}
      backCardStyle={backCardStyle}
      frontCardStyle={frontCardStyle}
    >
      <div className={styles.body}>
        <Grid columns={4} gap={16}>
          {menu.map((item) => {
            return <Grid.Item key={item.key}>{renderMenu(item)}</Grid.Item>;
          })}
        </Grid>
      </div>
    </HomeCard>
  );
};

export default Menu;
